import { defineStore } from 'pinia'

export const useFotoStore = defineStore({
  id: 'useFotoStore',
  state: () => ({
    foto: null as string | null,
    arquivo: null as File | null,
  }),
})
